import { gql } from "@apollo/client";

export const REMOVE_EVENT = gql`
  mutation removeEvent($id: Int!) {
    removeEvent(id: $id) {
      id
    }
  }
`;
